import { AbstractControl, ValidatorFn } from '@angular/forms';

export default class ValidationRegistro {
    static match(controlName: string, checkControlName: string): ValidatorFn {
        return (controls: AbstractControl) => {
            const control = controls.get(controlName);
            const checkControl = controls.get(checkControlName);

            if (checkControl?.errors && !checkControl.errors['match']) {
                return null;
            }

            if (control?.value !== checkControl?.value) {
                controls.get(checkControlName)?.setErrors({ match: true });
                return { match: true };
            } else {
                return null;
            }
        };
    }
}

